import { useState, useEffect } from "react";
import { Card, Form, Input, Row, Col, Select } from "antd";

import commonLookup from "../../services/commonLookupService";
import { getProfile } from "@seims/shared/src/security";
// import { ContactField } from "../custom/ContactField";
import { recordError } from "../../utils/logService";
import { ContactField, util } from "@seims/shared";

export default function ProjectLead({ onSetNextStatus, formRef, formData }) {
  const [titles, setTitles] = useState([]);
  const [defaultContact, setDefaultContact] = useState("+27");
  const [contactValue, setContactValue] = useState(
    formData?.contact || defaultContact
  );
  const [local, setLocal] = useState({ ...formData });
  const [current, setCurrent] = useState(0);

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "ProjectLeadForm";
  const formItemLayout = {
    layout: "vertical",
  };

  useEffect(() => {
    getTitles();
    getUserDetails();
  }, []);

  const getUserDetails = () => {
    const userInfo = getProfile();
    form.setFieldsValue({
      firstname: userInfo.firstName,
      surname: userInfo.lastName,
      email: userInfo.emailAddress,
    });

    if (formData?.contact) {
      setContactValue(formData?.contact);
    }
  };
  const getTitles = async () => {
    try {
      const response = await commonLookup.getTitles();
      if (response) {
        const { data } = response;
        setTitles(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onTitleChange = (selected) => {
    const selectedTitle = titles.find((record) => record.value == selected);
    form.setFieldsValue({ title: selectedTitle });
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const handleContactChange = (value) => {

    if (value === 0 || value.length < 10) {
      form.setFieldsValue({ contact: undefined });
      return;
    }
    form.setFieldsValue({ contact: value });
  };

  const onValuesChange = () => {
    const fields = form.getFieldsValue();
  };

  const onSubmit = async (values) => {
    // try {
    const { title, firstname, surname, contactNumber, email } = values;
    // const projectLeadData = {
    //   id: projectLeadData?.id > 0 ? projectLeadData.id : "-1",
    //   title: title,
    //   name: firstname,
    //   surname: surname,
    //   contactNumber: contactNumber,
    //   email: email,
    // };
    const request = "Done";
    // const request = await api.addProjectLead(projectLeadData);
    var msg;
    try {
      await form.validateFields(["title", "contact"]);
      setCurrent((prev) => prev + 1);
    } catch (error) {}
    // } catch (error) {

    //   recordError(error);
    // }
  };

  return (
    <>
      <Card
        className="project-card"
        title={
          <span
            style={{ color: "black", fontWeight: "bold", fontSize: "20px" }}
          >
            <b>STEP 1: Project Lead</b>
          </span>
        }
        bordered={false}
        headStyle={{ border: 0, textAlign: "left" }}
      >
        <p style={{ textAlign: "left" }}>Who is the project leader?</p>
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          onFinish={onSubmit}
          onValuesChange={onValuesChange}
          scrollToFirstError
          ref={formRef}
          initialValues={formData}
        >
          <Row>
            <Col xs={22} sm={20} md={6}>
              <Form.Item
                name="title"
                label="Title"
                rules={[
                  {
                    required: true,
                    message: "Please select title",
                  },
                ]}
                // className="custom-select"
              >
                <Select onChange={onTitleChange}>
                  {titles.map((title) => (
                    <Option key={title.key} value={title.value}>
                      {title.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col md={2}></Col>
            <Col xs={22} sm={20} md={6}>
              <Form.Item
                name="firstname"
                label="Name"
                rules={[
                  {
                    pattern: new RegExp("[A-Za-z]"),
                    message: "Provided charaters not allowed",
                  },
                  {
                    required: true,
                    message: "Please enter your name",
                  },
                ]}
              >
                <Input name="firstname" onBlur={onNameBlur} disabled />
              </Form.Item>
            </Col>
            <Col md={2}></Col>
            <Col xs={22} sm={20} md={6}>
              <Form.Item
                name="surname"
                label="Surname"
                rules={[
                  {
                    pattern: new RegExp("[A-Za-z]"),
                    message: "Provided charaters not allowed",
                  },
                  {
                    required: true,
                    message: "Please enter your surname",
                  },
                ]}
              >
                <Input name="surname" onBlur={onNameBlur} disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={22} sm={20} md={6}>
              <Form.Item
                name="contact"
                label="Contact number"
                rules={[
                  {
                    required: true,
                    message: "Please enter your contact number",
                  },
                ]}
              >
                <ContactField
                  contactValue={contactValue}
                  onContactChange={handleContactChange}
                />
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col xs={22} sm={20} md={6}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "Please insert your email",
                  },
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                ]}
              >
                <Input name="email" disabled />
              </Form.Item>
            </Col>
          </Row>
          <br />
        </Form>
      </Card>
    </>
  );
}
